import { PricedBond } from "../../../bonds/PricedBond";
import { Flex } from "@goodfill/ui-components";
import { Link } from "../../../../ui-components/Link/Link";
import { Info } from "../../../Info";
import {
  CouponPaymentComponent,
  MakeWholeCallComponent,
  MaturityDateComponent,
} from "@goodfill/domain-properties-components";
import "./CreateOrderBondData.scss";
import "./commonFormStyles.scss";
import { route } from "../../../../routes";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { TIMEZONE_NEY_YORK } from "../../../../locale/timezone";

interface Props {
  pricedBond: PricedBond;
}

export const CreateOrderBondData: React.FC<Props> = ({ pricedBond }) => {
  const isin = pricedBond.isin;
  const ticker = pricedBond.issuerTicker;

  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Flex direction="row" gap={2} justify="center">
      <Flex direction="col" gap={2} className="info-details-container px-8 py-6">
        <div className="grid gap-12 grid-cols-5 grid-rows-2 grid-responsive">
          <Info label="Ticker" className="flex info-details">
            {ticker}
          </Info>
          <Info label="Coupon" className="flex info-details w-full">
            <CouponPaymentComponent value={pricedBond.couponPayment} />
          </Info>
          <Info label="Maturity" className="flex info-details">
            <MaturityDateComponent value={pricedBond.maturityDate} timezone={TIMEZONE_NEY_YORK} />
          </Info>
          <Info label="S&P Rating" className="flex info-details">
            {pricedBond.ratings.sp}
          </Info>
          <Info label="Moody's Rating" className="flex info-details">
            {pricedBond.ratings.moodys}
          </Info>
          <Info label="Payment Rank" className="flex info-details">
            {pricedBond.paymentRank}
          </Info>
          <Info label="ISIN" className="flex info-details w-full">
            {isin}
          </Info>
          {pricedBond.makeWholeCall != null && (
            <Info label="Make Whole Call" className="flex info-details">
              <MakeWholeCallComponent value={pricedBond.makeWholeCall} />
            </Info>
          )}

          <Flex verticalMargin={4} direction="row" justify="end" style={{ gridRow: "span 2" }}>
            <Flex width={32}>
              <Link onClick={() => navigate(route.bondDetail(pricedBond.bondIdCusip))} icon>
                {t("callToAction.details")}
              </Link>
            </Flex>
          </Flex>
        </div>
      </Flex>
    </Flex>
  );
};
